import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="crazy-footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h2>
            <span>Auto</span>Pro ☀️
          </h2>
          <p className="footer-tagline">מובילים את הקיץ – חדשנות, נוחות וסגנון בכל נסיעה</p>
        </div>

        <div className="footer-links">
          <Link to="/">דף הבית</Link>
          <Link to="/products">מוצרים</Link>
          <Link to="/contact">צור קשר</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AutoPro | כל הזכויות שמורות</p>
      </div>
    </footer>
  );
};

export default Footer;
